import {CultureAnalysisPdfComponentWrapper} from './CultureAnalysisPdfComponentWrapper';
import {CultureAnalysisPdfProvider} from '../../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfProvider';

export const CultureAnalysisPdfPage = () => {
  return (
    <CultureAnalysisPdfProvider>
      <CultureAnalysisPdfComponentWrapper />
    </CultureAnalysisPdfProvider>
  );
};
